import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
var router=new Router({
  routes: [
    {
      path: '/',
      redirect: '/chongqing/products'
    },
    { // 陕西宽带手机端预约 H5预约
      path: '/shaanxi/broadbandappoint',
      name: 'broadband',
      meta: {
          title: '宽带预约'
      },
      component: () => import('@/views/shaanxi/broadbandappoint')
    },
    { // 中国移动-陕西移动 视频大流量包-解约赔付协议页面
      path: '/shaanxi/sypayoutprotocol',
      name: 'sypayoutprotocol',
      meta: {
          title: '视频大流量包'
      },
      component: () => import('@/views/shaanxi/sypayoutprotocol')
    },
    { // 中国移动-陕西移动 视频大流量包-快手
      path: '/shaanxi/videoflowbag',
      name: 'saanxivideoflowbagKS',
      meta: {
          title: '视频大流量包'
      },
      component: () => import('@/views/shaanxi/videoflowbag/indexKS')
    },
    { // 中国移动-陕西移动 流量包-微信公众号
      path: '/shaanxi/flowbagvx',
      name: 'saanxiflowbagvx',
      meta: {
          title: '流量包'
      },
      component: () => import('@/views/shaanxi/videoflowbag/indexVX')
    },
    { // 中国移动-陕西移动 视频大流量包-微信推广
      path: '/videoflowbag/mk',
      name: 'saanxivideoflowbagother',
      meta: {
          title: '视频大流量包'
      },
      component: () => import('@/views/shaanxi/videoflowbag/mkCommon')
    },
    { // 中国移动-陕西移动 订单查询Demo
      path: '/shaanxi/demo/orders',
      name: 'shaanxiDemoOrders',
      meta: {
          title: '订单查询Demo'
      },
      component: () => import('@/views/shaanxi/demo/orders')
    },
    { // 中国移动-陕西移动 视频大流量包30元30G
      path: '/videoflowbag/indexThree',
      name: 'saanxivideoflowbag',
      meta: {
          title: '移动视频大流量包'
      },
      component: () => import('@/views/shaanxi/videoflowbag/indexThree')
    },
    { // 宁夏话费宝拉新注册登录
      path: '/marketing/nxPullnew/login',
      name: 'nxPullnewLogin',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/login')
    },
    { // 宁夏话费宝拉新首页
      path: '/marketing/nxPullnew/index',
      name: 'pullnewIndex',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/index')
    },
    { // 宁夏话费宝支付宝拉新二维码
      path: '/marketing/nxPullnew/tbQrCode',
      name: 'tbQrCode',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/tbQrCode')
    },
    {
      path: '/marketing/nxPullnew/tbQuery',
      name: 'tbQuery',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/tbQuery')
    },
    {
      path: '/marketing/nxPullnew/tbGuide',
      name: 'tbGuide',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/tbGuide')
    },
    { // 宁夏话费宝支付宝拉新二维码
      path: '/marketing/nxPullnew/zfbQrCode',
      name: 'zfbQrCode',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/zfbQrCode'),
    },
    {
      path: '/marketing/nxPullnew/zfbQuery',
      name: 'zfbQuery',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/zfbQuery')
    },
    {
      path: '/marketing/nxPullnew/zfbGuide',
      name: 'zfbGuide',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/zfbGuide')
    },
    { // 宁夏话费宝打款记录
      path: '/marketing/nxPullnew/paylist',
      name: 'paylistH5',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/paylist')
    },
    { // 宁夏话费宝提现
      path: '/marketing/nxPullnew/balance',
      name: 'balance',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/balance')
    },
    { // 宁夏话费个人信息设置
      path: '/marketing/nxPullnew/setting',
      name: 'setting',
      meta: {
          title: '拉新赚佣',
          isLoginNxPullNew:true
      },
      component: () => import('@/views/nxPullnew/setting')
    },
    { // 辽宁移动 流量充值
      path: '/liaoning/flowcharge',
      name: 'lnFlowCharge',
      meta: {
          title: '流量充值'
      },
      component: () => import('@/views/liaoning/flowcharge')
    },
    { // 山东移动 流量充值
      path: '/shandong/flowcharge',
      name: 'sdFlowCharge',
      meta: {
          title: '流量充值'
      },
      component: () => import('@/views/shandong/flowcharge')
    },
    { //冰蓝话费平台 
      path: '/bluerecharge',
      name: 'bluerecharge',
      redirect: '/bluerecharge/start',
      meta: {
          title: '数据平台'
      },
      component: () => import('@/views/bluerecharge/start'),
      children:[
        {
          path: 'login',
          name: 'bluerechargeLogin',
          component: () => import('@/views/bluerecharge/login'),
          meta: {
            title: '数据平台'
          }
        },
        {
          path: 'index',
          name: 'bluerechargeIndex',
          component: () => import('@/views/bluerecharge/index'),
          meta: {
            title: '数据平台'
          },
          children:[
            {
              path: '/bluerecharge/index',
              name: 'bluerechargeHome',
              component: () => import('@/views/bluerecharge/home'),
              meta: {
                title: '数据平台'
              }
            },
            {
              path: '/bluerecharge/rechargeRecord',
              name: 'bluerechargeRecord',
              component: () => import('@/views/bluerecharge/rechargeRecord'),
              meta: {
                title: '数据平台'
              },
            },
            {
              path: '/bluerecharge/depositSubmit',
              name: 'bluerechargeSubmit',
              component: () => import('@/views/bluerecharge/capitalManage/depositSubmit'),
              meta: {
                title: '数据平台'
              },
            },
            {
              path: '/bluerecharge/depositQuery',
              name: 'bluerechargeQuery',
              component: () => import('@/views/bluerecharge/capitalManage/depositQuery'),
              meta: {
                title: '数据平台'
              },
            },
            {
              path: '/bluerecharge/orderQuery',
              name: 'bluerechargeOrderQuery',
              component: () => import('@/views/bluerecharge/orderQuery'),
              meta: {
                title: '数据平台'
              },
            },
          ]
        },
      ]
    },
    { //陕西移动号卡下单
      path: '/shaanxi',
      name: 'shaanxiNumberCard',
      redirect: '/shaanxi/numberCard/start',
      meta: {
          title: '号卡下单'
      },
      component: () => import('@/views/shaanxi/numberCard/start'),
      children:[
        {
          path: 'numCardIndex',
          name: 'shaanxiPlaceOrder',
          component: () => import('@/views/shaanxi/numberCard/index'),
          meta: {
            title: '资料填写'
          }
        },
        {
          path: 'orderConfirm',
          name: 'orderConfirm',
          component: () => import('@/views/shaanxi/numberCard/orderConfirm'),
          meta: {
            title: '信息确认'
          }
        },
        {
          path: 'orderDetail',
          name: 'orderDetail',
          component: () => import('@/views/shaanxi/numberCard/orderDetail'),
          meta: {
            title: '订单详情'
          }
        },
        {
          path: 'protocol',
          name: 'shaanxiProtocol',
          component: () => import('@/views/shaanxi/numberCard/protocol'),
          meta: {
            title: '服务协议'
          }
        }
      ]
    },
    ,
    { //重庆移动号卡下单
      path: '/chongqing',
      name: 'chongqingNumberCard',
      redirect: '/chongqing/numberCard/start',
      meta: {
          title: '号卡下单'
      },
      component: () => import('@/views/chongqing/numberCard/start'),
      children:[
        {
          path: 'products',
          name: 'chongqingProducts',
          component: () => import('@/views/chongqing/numberCard/products'),
          meta: {
            title: '产品列表'
          }
        },
        {
          path: 'numCardIndex',
          name: 'chongqingPlaceOrder',
          component: () => import('@/views/chongqing/numberCard/index'),
          meta: {
            title: '资料填写'
          }
        },
        {
          path: 'wxOrder',
          name: 'chongqingWxOrder',
          component: () => import('@/views/chongqing/numberCard/wxOrder'),
          meta: {
            title: '移动渝星卡'
          }
        },
        {
          path: 'wxOrderDetails',
          name: 'chongqingWxOrderDetails',
          component: () => import('@/views/chongqing/numberCard/wxOrderDetails'),
          meta: {
            title: '渝星卡-资料填写'
          }
        },
        {
          path: 'orderConfirm',
          name: 'cqOderConfirm',
          component: () => import('@/views/chongqing/numberCard/orderConfirm'),
          meta: {
            title: '信息确认'
          }
        },
        {
          path: 'orderDetail',
          name: 'cqOrderDetail',
          component: () => import('@/views/chongqing/numberCard/orderDetail'),
          meta: {
            title: '订单详情'
          }
        },
        {
          path: 'queryLogistics',
          name: 'queryCQLogistics',
          component: () => import('@/views/chongqing/numberCard/queryLogistics'),
          meta: {
            title: '订单在线 一键查询'
          }
        },
        {
          path: 'protocol',
          name: 'chongqingProtocol',
          component: () => import('@/views/chongqing/numberCard/protocol'),
          meta: {
            title: '服务协议'
          }
        }
      ]
    },
    { //领取礼品
      path: '/giftExchange',
      name: 'giftExchange',
      redirect: '/giftExchange/start',
      meta: {
          title: '礼品列表'
      },
      component: () => import('@/views/giftExchange/start'),
      children:[
        {
          path: 'index',
          name: 'giftExchangeIndex',
          component: () => import('@/views/giftExchange/index'),
          meta: {
            title: '礼品列表'
          }
        },
        {
          path: '/giftExchange/orderConfirm',
          name: 'giftExchangeOrder',
          component: () => import('@/views/giftExchange/orderConfirm'),
          meta: {
            title: '下单'
          }
        },
        {
          path: '/chongqing/protocol',
          name: 'chongqingProtocol',
          component: () => import('@/views/chongqing/numberCard/protocol'),
          meta: {
            title: '服务协议'
          }
        }
      ]
    },
    {
      path: '/marketingService/index',
      name: 'marketingServiceIndex',
      component: () => import('@/views/marketingService/index'),
      meta: {
        title: '客服二维码'
      }
    },
    { //口碑券领取、成功页面
      path: '/kbCoupon',
      name: 'kbCoupon',
      redirect: '/kbCoupon/start',
      meta: {
          title: '领取口碑券'
      },
      component: () => import('@/views/kbCoupon/start'),
      children:[
        {
          path: 'receive',
          name: 'kbCouponIndex',
          component: () => import('@/views/kbCoupon/receive'),
          meta: {
            title: '领取口碑券'
          }
        },
        {
          path: 'resultpage',
          name: 'kbCouponResultpage',
          component: () => import('@/views/kbCoupon/resultpage'),
          meta: {
            title: '领券结果'
          }
        },
      ]
    },
    {
      path: '/zfb/qrcode',
      name: 'zfb.qrcode',
      component: () => import('@/views/zfb/qrcode'),
      meta: {
        title: '支付二维码'
      }
    }
  ]
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js